import React from "react";
import { useConfig } from "./ConfigContext";

export const isDefaultSession = (session) => {
  // Implement a function to check if session is default
  // For example, assuming that if session is an empty object, it's considered as default
  return Object.keys(session).length === 0;
};

export const isDefaultMessages = (messages) => {
  // Implement a function to check if messages is default
  // For example, assuming that if messages is an empty array, it's considered as default
  return messages.length === 0;
};

export function scrollHistoryToBottom() {
  document
    .querySelector(".magicform-scroll-anchor")
    ?.scrollIntoView({ behavior: "smooth" });
}

/**
 * generate styling for anchor tags in the widget
 *
 * @param {import("../../types/config").StackEmbedConfigObject} config
 * @param {import("../../types/config").ColorValues} colors
 */
export function generateLinkStyles(config, colors) {
  return (
    <style>
      {`
        a.widget-link:not(:hover):not(:active) {
          color: ${colors.linkRegularText};
          text-decoration: ${config.linkRegularDecoration};
          background-color: ${colors.linkRegularBackground};
          font-size: ${config.linkRegularFontSize};
          font-weight: ${config.linkRegularFontWeight};
        }
        a.widget-link:hover {
          color: ${colors.linkHoverText};
          text-decoration: ${config.linkHoverDecoration};
          background-color: ${colors.linkHoverBackground};
          font-size: ${config.linkHoverFontSize};
          font-weight: ${config.linkHoverFontWeight};
        }
        a.widget-link:active {
          color: ${colors.linkActiveText};
          text-decoration: ${config.linkActiveDecoration};
          background-color: ${colors.linkActiveBackground};
          font-size: ${config.linkActiveFontSize};
          font-weight: ${config.linkActiveFontWeight};
        }
    `}
    </style>
  );
}
